import { Combined_DeleteInheritance } from '../commands/combined';
import Controller from './Controller';
import type Report from '../checks/Report';
import type { OrId, IdOptionMap } from '../commands/types';
import type { IInheritance } from '../../stores/model/metamodel/inheritance';

export default class DeleteInheritanceController extends Controller {
  async deleteInheritance(
    id: OrId<IInheritance>,
    specialisedEventOptions?: IdOptionMap | null
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteInheritance(model, id, specialisedEventOptions);
      return checks;
    });
  }
}
